import { useState, useEffect } from 'react';

// custom hooks take advantage of useEffect, which takes place before the component renders
// useEffect    - https://reactjs.org/docs/hooks-effect.html
// Custom Hooks - https://reactjs.org/docs/hooks-custom.html
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return width;
}

export default useWindowWidth;
